import { clearSection } from 'dmpconnectjsapp-base/actions';
import { apiSections } from 'dmpconnectjsapp-base/constants';
import { Form, Formik } from 'formik';
import moment from 'moment';
import React from 'react'
import { Modal, Form as BootstrapForm, Col, Button } from 'react-bootstrap';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import InputDate from '../Common/Form/Input/InputDate';

const validationSchema = Yup.object().shape({
  birthday: Yup.string()
    .test('is-date', 'Date invalide', value => {
      if (!value) return false;
      const [day, month, year] = value.split('/');
      
      if (Number(day) > 31 || Number(month) > 12) {
        const lunarDate = new Date(Number(year), Number(month), Number(day)).toString();
        return moment(lunarDate).isValid();
      }
      return moment(`${year}-${month}-${day}`, "YYYY-MM-DD", true).isValid();
    })
    .required("Valeur requise"),
  nir: Yup.string()
    .matches(/^[A-Za-z0-9]{15}$/, "Le NIR doit contenir 15 caractères (chiffres ou lettres)")
    .required("Valeur requise"),
  birthRank: Yup.number()
    .typeError("La valeur doit être un nombre")
    .max(1, "La valeur doit être un chiffre unique")
    .integer("La valeur doit être un nombre entier")
    .required("Valeur requise"),
  regime: Yup.string()
    .min(2, "La valeur doit contenir exactement 2 chiffres")
    .max(2, "La valeur doit contenir exactement 2 chiffres")
    .matches(/^\d{2}$/, "La valeur doit contenir exactement 2 chiffres")
    .required("Valeur requise"),
  desk: Yup.string()
    .min(3, "La valeur doit contenir exactement 3 chiffres")
    .max(3, "La valeur doit contenir exactement 3 chiffres")
    .matches(/^\d{3}$/, "La valeur doit contenir exactement 3 chiffres"),
  center: Yup.string()
    .min(4, "La valeur doit contenir exactement 4 chiffres")
    .max(4, "La valeur doit contenir exactement 4 chiffres")
    .matches(/^\d{4}$/, "La valeur doit contenir exactement 4 chiffres"),
});

function PatientDataFormModal({
  displayFormModalState,
  currentIndex,
  vitaleIndex,
  dispatch,
  handleSendingRequest
}) {
  const [displayFormModal, setDisplayFormModal] = displayFormModalState;
  return (
     <Modal 
        show={displayFormModal && currentIndex === vitaleIndex}
        centered
        onHide={() => {
          setDisplayFormModal(false);
          dispatch(clearSection(apiSections.CREATE_CONNECTION));
          dispatch(clearSection(apiSections.GENERATE_EMPTY_TLSI_REQUEST));
      }}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Recherche Manuelle</Modal.Title>
        </Modal.Header>
          <Formik
            validationSchema={validationSchema} 
            onSubmit={(values) => handleSendingRequest(values)} 
            initialValues={{
              birthRank: 1,
            }}
          >
            {(
              {
                handleSubmit,
                handleChange,
                values,
                errors,
                isValid,
                isSubmitting,
              },
            ) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Body>
              <BootstrapForm.Row>
                <Col md={6}>
                  <BootstrapForm.Label>NIR du patient</BootstrapForm.Label>
                  <BootstrapForm.Control
                    name="nir"
                    placeholder="123456789012345"
                    label="NIR"
                    value={values.nir}
                    onChange={handleChange}
                    required
                  /> 
                  <BootstrapForm.Text className="text-danger">{errors.nir}</BootstrapForm.Text>
                </Col>
                <Col md={6}>
                  <BootstrapForm.Label>Date de naissance</BootstrapForm.Label>
                  <InputDate
                    size="sm"
                    name="birthday"
                    placeholder="JJ/MM/AAAA"
                    id="birthday"
                    value={values.birthday || ""}
                    onChange={handleChange}
                    required
                  />
                  <BootstrapForm.Text className="text-danger">{errors.birthday}</BootstrapForm.Text>
                </Col>
              </BootstrapForm.Row>
              <BootstrapForm.Row className="mt-3">
                <Col md={3}>
                  <BootstrapForm.Label>Rang de naissance</BootstrapForm.Label>
                  <BootstrapForm.Control
                    name="birthRank"
                    label="Rang de naissance"
                    value={values.birthRank}
                    onChange={handleChange}
                    placeholder='1'
                    required
                  />
                  <BootstrapForm.Text className="text-danger">{errors.birthRank}</BootstrapForm.Text>
                </Col>
                <Col md={3}>
                  <BootstrapForm.Label>Régime</BootstrapForm.Label>
                  <BootstrapForm.Control
                    name="regime"
                    label="Régime"
                    value={values.regime}
                    onChange={handleChange}
                    pattern='^\d{2}$'
                    maxLength={2}
                    minLength={2}
                    placeholder='01'
                    required
                  />
                  <BootstrapForm.Text className="text-danger">{errors.regime}</BootstrapForm.Text>
                </Col>
                <Col md={3}>
                    <BootstrapForm.Label>Code Caisse (optionnel)</BootstrapForm.Label>
                    <BootstrapForm.Control 
                      name="desk"
                      value={values.desk} 
                      onChange={handleChange}
                      pattern='^\d{3}$'
                      maxLength={3}
                      minLength={3}
                      placeholder='001'
                    />
                    <BootstrapForm.Text className="text-danger">{errors.desk}</BootstrapForm.Text>
                </Col>
                <Col md={3}>
                    <BootstrapForm.Label>Code centre (optionnel)</BootstrapForm.Label>
                    <BootstrapForm.Control 
                      name="center"
                      value={values.center} 
                      onChange={handleChange}
                      pattern='^\d{4}$'
                      maxLength={4}
                      minLength={4}
                      placeholder='0001'
                    />
                    <BootstrapForm.Text className="text-danger">{errors.center}</BootstrapForm.Text>
                </Col>
              </BootstrapForm.Row>

              </Modal.Body>
              <Modal.Footer>
                <Button variant="borderless-primary" onClick={() => {
                  setDisplayFormModal(false);
                  dispatch(clearSection(apiSections.CREATE_CONNECTION));
                  dispatch(clearSection(apiSections.GENERATE_EMPTY_TLSI_REQUEST));
                }}>
                  Annuler
                </Button>

                <Button
                  type="submit"
                  variant="primary"
                  disabled={isSubmitting || !isValid}
                >
                  Obtenir le médecin traitant
                </Button>
              </Modal.Footer>
            </Form>
            )}
          </Formik>
      </Modal>
  )
}

export default PatientDataFormModal

PatientDataFormModal.propTypes = {
  displayFormModalState: PropTypes.array.isRequired,
  currentIndex: PropTypes.number,
  vitaleIndex: PropTypes.number,
  dispatch: PropTypes.func.isRequired,
  handleSendingRequest: PropTypes.func.isRequired,
}
PatientDataFormModal.defaultProps = {
  currentIndex: undefined,
  vitaleIndex: undefined,
}